module.exports = __webpack_public_path__ + "4c39032fc9639df8a565ab63c7f84221.fbx";